import EventEmitter from 'eventemitter3';
import type { CoreAPI } from './api';
import { type Hook, presetHook } from '../hook';
import * as ui from '../ui';
import * as helper from '../helper';
import * as util from '../util';
import type { LifecycleEvent as StandardChartLifecycleEvent } from './MainStandardChartView';
import type { View } from './View';

type LifecycleEvent = {
  //
} & StandardChartLifecycleEvent;

type ViewKey =
  | 'NormalView'
  | 'StandardChartView'
  | 'HXKLineView__main'
  | 'ExternalView'
  | 'HXKLineView__secondary';

export const buildExtensionApi = ({
  coreAPI,
  hook,
  visId
}: {
  coreAPI: CoreAPI;
  hook: Hook;
  visId: string;
}) => {
  return {
    ...coreAPI,

    // internal
    cache: new Map<string, unknown>(),

    views: {} as {
      [key in ViewKey]: View;
    },

    baseDom: {} as { $container: HTMLElement; $mainView: HTMLElement; $secondaryView: HTMLElement },

    // plugin
    hook,
    presetHook,

    // ui
    ui,

    // helper
    helper,

    // util
    util,

    // 生命周期函数
    lifecycle: new EventEmitter<LifecycleEvent>(),

    // 唯一标识
    visId
  };
};

export type ExtensionApi = ReturnType<typeof buildExtensionApi>;
